module.exports = __webpack_public_path__ + "img/qr_not_arrow.2cd8eae4.svg";